import e from "./assets/06a3d5bb601cd02f.svg";
import a from "./assets/8980ed7a9779ec56.svg";
import i from "./assets/49d6ca2565fb8005.svg";
import t from "./assets/d2ff14c84a3aedad.svg";
import l from "./assets/1505fd59e41abc7a.svg";
import m from "./assets/41cff5026a464e32.svg";
import n from "./assets/3070a1415afb4abb.svg";
import c from "./assets/99a59c1fa400d465.svg";
import s from "./assets/08c83038846f341a.svg";
import p from "./assets/84a735d723f9776c.svg";
import d from "./assets/3e8450b83bedc0b0.svg";
import f from "./assets/89db7a3c86f759ed.svg";
import h from "./assets/14e40bc4a36c19d1.svg";
import g from "./assets/a7f8c6b3ab8b9985.svg";
import u from "./assets/ee359fa92500d26e.svg";
import w from "./assets/ac8f0bc9c93df4aa.svg";
import b from "./assets/84a7d2491e19d6db.svg";
import U from "./assets/f22a2b41bbb35dca.svg";
import k from "./assets/51791b8875546209.svg";
import y from "./assets/ddf04544b44793d7.svg";
import v from "./assets/d8a530f261f92406.svg";
import $ from "./assets/6f21909440b9ad84.svg";
import x from "./assets/b87ddef5e19b111a.svg";
import A from "./assets/2ccfe469da54d9b5.svg";
import C from "./assets/bce0ded315907e13.svg";
import D from "./assets/6201121d303cd3ae.svg";
import z from "./assets/95a504df508d129f.svg";
import S from "./assets/8bda7aab26386ad9.svg";
import M from "./assets/8f0d0b58d242a35f.svg";
import q from "./assets/c1286858b15f83ce.svg";
import P from "./assets/6f080e0e1d2de577.svg";
import R from "./assets/6ba168a7963e5595.svg";
import B from "./assets/e1d790c68f543b39.svg";
import L from "./assets/fbd0336624acaaa5.svg";
import T from "./assets/3695bb1e6d443d8e.svg";
import E from "./assets/b23ca7153082e746.svg";
import H from "./assets/1f1e9fe8b29328f6.svg";
import F from "./assets/f939679add25a2dd.svg";
import G from "./assets/7fa5aec0b38de102.svg";
import I from "./assets/9a4d48a6eb4f5f76.svg";
import O from "./assets/b5964a47107bb1ce.svg";
import j from "./assets/c3d1a14eef7b8a7e.svg";
import V from "./assets/372e641d9f9d6997.svg";
import X from "./assets/3c84959dc76d2591.svg";
import K from "./assets/a6ccf9e66e690f4f.svg";
import Q from "./assets/2309e506d38522d6.svg";
import N from "./assets/3c9fc09e4b93038b.svg";
import W from "./assets/9b0c34373a5f2360.svg";
import Z from "./assets/10054cc460c2cf9a.svg";
import J from "./assets/45acab2a7b6145ac.svg";
import Y from "./assets/cff58faa8942fe6f.svg";
import _ from "./assets/f6a5cf87aa72764c.svg";
import rr from "./assets/5b8da7beb0888841.svg";
import or from "./assets/510df08255a6921b.svg";
import er from "./assets/9eaf73329646c496.svg";
import ar from "./assets/745750811080aa5e.svg";
import ir from "./assets/7c2a27aa0e8cf546.svg";
import tr from "./assets/d7a32c8c7da150d8.svg";
import lr from "./assets/88b8813926eca118.svg";
import mr from "./assets/14ea76e7d0d04293.svg";
import nr from "./assets/06ee829acdb71c40.svg";
import cr from "./assets/5fd54545bf6dfcd8.svg";
import sr from "./assets/bf9a030a1ec3f875.svg";
import pr from "./assets/612c8c707462e51c.svg";
import dr from "./assets/0278c8dfc48a6950.svg";
import fr from "./assets/82582125668d5dc8.svg";
import hr from "./assets/e9ca37cdab222f9a.svg";
import gr from "./assets/0fa6557efc006743.svg";
import ur from "./assets/50caf8804cb94f43.svg";
import wr from "./assets/ee01ccdb60519aec.svg";
import br from "./assets/0eb63b2b3937c74a.svg";
import Ur from "./assets/7fd459947e9f2c55.svg";
import kr from "./assets/23ccfc28624428ad.svg";
import yr from "./assets/554f14eef48027ca.svg";
import vr from "./assets/beb09649f9a0c006.svg";
import $r from "./assets/7003550c39713595.svg";
import xr from "./assets/794153eb235da180.svg";
import Ar from "./assets/63c9283406ecda30.svg";
import Cr from "./assets/2cc2bbf6db68b107.svg";
import Dr from "./assets/03d55f3f8a58cf7f.svg";
import zr from "./assets/8811ea124d158bb3.svg";
import Sr from "./assets/ebd160735e22f99f.svg";
import Mr from "./assets/800ef1136ac55822.svg";
import qr from "./assets/45f4e15a7644add3.svg";
import Pr from "./assets/66fafaf14ab12525.svg";
import Rr from "./assets/9f5aa42083d2f50c.svg";
import Br from "./assets/5ff05d9508c16725.svg";
import Lr from "./assets/cb0d9a4cd1da3940.svg";
import Tr from "./assets/6e85c35f9fc7860d.svg";
import Er from "./assets/4bf608e8b337e686.svg";
import Hr from "./assets/91b5ad9c13464aee.svg";
import Fr from "./assets/90acf2ed32052560.svg";
import Gr from "./assets/e93db083cd1ecf6e.svg";
import Ir from "./assets/9c9994c305c33f2d.svg";
import Or from "./assets/38da7de36057af07.svg";
import jr from "./assets/fe6cc71e770e2c6e.svg";
import Vr from "./assets/227f547c58d13bce.svg";
import Xr from "./assets/cf32ee49f9484daa.svg";
import Kr from "./assets/eed7daf4b748a396.svg";
import Qr from "./assets/f4e19294e5ca831b.svg";
import Nr from "./assets/90bf153b7743ba8d.svg";
import Wr from "./assets/c9937356d3f67444.svg";
import Zr from "./assets/68b91b161e5afaca.svg";
import Jr from "./assets/bf745de25a6ebece.svg";
import Yr from "./assets/26ec3886f9c4f57f.svg";
import _r from "./assets/fb00509ebe5ea0ec.svg";
import ro from "./assets/2db3933934719fb1.svg";
import oo from "./assets/783e00dc26e3fa59.svg";
import eo from "./assets/1a5821e0d3dd722c.svg";
import ao from "./assets/602e99e6b4e073e4.svg";
import io from "./assets/aaa5be5cebf703b0.svg";
import to from "./assets/a3651330c8c6922b.svg";
import lo from "./assets/47017149cc68e7d0.svg";
import mo from "./assets/62548266dcc0a60d.svg";
import no from "./assets/3722f3306c0ffbba.svg";
import co from "./assets/edf2359d6810a31e.svg";
import so from "./assets/7c2bc884d57ffd06.svg";
import po from "./assets/cd409711559b435d.svg";
import fo from "./assets/4b5e46a157819e4c.svg";
import ho from "./assets/ae7ee922fff859d7.svg";
import go from "./assets/8788f309ff9a9cd2.svg";
import uo from "./assets/65355061e83da121.svg";
import wo from "./assets/0b44134d86a6cf02.svg";
import bo from "./assets/73b153e58be6c566.svg";
import Uo from "./assets/9e063e56779cf06d.svg";
import ko from "./assets/8c03b284b195c24b.svg";
import yo from "./assets/5f8c90a6399a217f.svg";
import vo from "./assets/8b1bc6a872bee828.svg";
import $o from "./assets/7ef65c8f2ad0839c.svg";
import xo from "./assets/2ef09122439b62a2.svg";
import Ao from "./assets/7a70754f71d42ba8.svg";
import Co from "./assets/aea7d39df5bf92af.svg";
import Do from "./assets/3a96bc92e1fa5803.svg";
import zo from "./assets/0fa17012252f2f2c.svg";
import So from "./assets/a60c0888b231a032.svg";
import Mo from "./assets/ca758cdb2e888b0f.svg";
import qo from "./assets/2c5b12c8f2a18b2a.svg";
import Po from "./assets/5bcfcfcd0838ba24.svg";
import Ro from "./assets/1e1efe171dd451bd.svg";
import Bo from "./assets/44b81db313baeefc.svg";
import Lo from "./assets/938f52f7bc17f163.svg";
import To from "./assets/2de967028b73d3ad.svg";
import Eo from "./assets/90943e0b579f5714.svg";
import Ho from "./assets/31fb7599c2716d4a.svg";
import Fo from "./assets/bc055cbef804633f.svg";
import Go from "./assets/d317141e36097ac5.svg";
import Io from "./assets/ba4c6b4d4ea19b20.svg";
import Oo from "./assets/98f49ee410193c84.svg";
import jo from "./assets/aa9929b5afdfac72.svg";
import Vo from "./assets/6c837504da58a177.svg";
import Xo from "./assets/ea28972f0ca4eb85.svg";
import Ko from "./assets/8d5476a0ea9334a9.svg";
import Qo from "./assets/18146b42fccd9097.svg";
import No from "./assets/00562c83127d3e5c.svg";
import Wo from "./assets/a3ace5fd461d77a7.svg";
import Zo from "./assets/a9df93f2d0b45960.svg";
import Jo from "./assets/e1946c7d8ced7ba0.svg";
import Yo from "./assets/9d40e44fd686a6d3.svg";
import _o from "./assets/d4c91e6b89beef76.svg";
import re from "./assets/78b40d84c041268f.svg";
import oe from "./assets/32a87b1a2d449a72.svg";
import ee from "./assets/00d9de3d51a7c229.svg";
import ae from "./assets/79cbe576557eb480.svg";
import ie from "./assets/4a3b8067fe3baabc.svg";
import te from "./assets/b47a30708798c208.svg";
import le from "./assets/d41a883982ec3682.svg";
import me from "./assets/1c348688be0ae0e3.svg";
import ne from "./assets/2b85b2d4da772f9c.svg";
import ce from "./assets/5bbd1fa266bea27f.svg";
import se from "./assets/8bb62dba053f0252.svg";
import pe from "./assets/25a31967edeff2c2.svg";
import de from "./assets/395b47fd7c0f81bd.svg";
import fe from "./assets/158ccbff9a2039f9.svg";
import he from "./assets/d30ccf2460aa5589.svg";
import ge from "./assets/38dc908ac99bd73d.svg";
import ue from "./assets/d34135d031a5d9f1.svg";
import we from "./assets/94902d4390fa8165.svg";
import be from "./assets/3670797f3ccbffb9.svg";
import Ue from "./assets/3a54497862c283aa.svg";
import ke from "./assets/2c7da4b8026440b0.svg";
import ye from "./assets/e38fc2b4e220f706.svg";
const r = {
  0: e,
  1: a,
  2: i,
  3: t,
  "360-degrees": l,
  4: m,
  5: n,
  6: c,
  7: s,
  8: p,
  9: d,
  anchor: f,
  "arrow-down-left": h,
  "arrow-down-right": g,
  "arrow-down": u,
  "arrow-left": w,
  "arrow-right": b,
  "arrow-rotate-left": U,
  "arrow-rotate-right": k,
  "arrow-up-left": y,
  "arrow-up-right": v,
  "arrow-up": $,
  bandage: x,
  bomb: A,
  book: C,
  books: D,
  "briefcase-medical": z,
  briefcase: S,
  "bullseye-arrow": M,
  calculator: q,
  camera: P,
  "caret-up": R,
  cars: B,
  check: L,
  "chevron-down": T,
  "chevron-left": E,
  "chevron-right": H,
  "chevron-up": F,
  circle: G,
  clock: I,
  compass: O,
  "door-open": j,
  "down-from-line": V,
  down: X,
  "earth-americas": K,
  exclamation: Q,
  fire: N,
  flag: W,
  gear: Z,
  "graduation-cap": J,
  "hand-pointer": Y,
  handshake: _,
  "heart-crack": rr,
  heart: or,
  "helmet-safety": er,
  info: ar,
  key: ir,
  "kit-medical": tr,
  left: lr,
  "location-dot": mr,
  "magnifying-glass-minus": nr,
  "magnifying-glass-plus": cr,
  "magnifying-glass": sr,
  "map-pin": pr,
  map: dr,
  microphone: fr,
  minus: hr,
  palette: gr,
  pencil: ur,
  "person-to-door": wr,
  "person-to-portal": br,
  plane: Ur,
  plus: kr,
  question: yr,
  radiation: vr,
  reply: $r,
  right: xr,
  road: Ar,
  "shield-check": Cr,
  ship: Dr,
  stairs: zr,
  star: Sr,
  stopwatch: Mr,
  "thumbs-up": qr,
  "triangle-exclamation": Pr,
  up: Rr,
  "user-helmet-safety": Br,
  video: Lr,
  wrench: Tr,
  xmark: Er
};
function jt(o) {
  return o in r;
}
const ve = [
  {
    id: "info",
    label: "Info",
    search: [
      "details",
      "help",
      "information",
      "more",
      "support"
    ]
  },
  {
    id: "door-open",
    label: "Door Open",
    search: [
      "enter",
      "exit",
      "welcome"
    ]
  },
  {
    id: "pencil",
    label: "Pencil",
    search: [
      "Lower Left Pencil",
      "design",
      "draw",
      "edit",
      "lead",
      "maintenance",
      "modify",
      "pencil",
      "update",
      "write"
    ]
  },
  {
    id: "7",
    label: "7",
    search: [
      "Digit Seven",
      "seven"
    ]
  },
  {
    id: "up",
    label: "Up",
    search: [
      "upgrade",
      "upload"
    ]
  },
  {
    id: "reply",
    label: "Reply",
    search: [
      "mail",
      "message",
      "respond"
    ]
  },
  {
    id: "compass",
    label: "Compass",
    search: [
      "compass",
      "directions",
      "directory",
      "location",
      "magnetic",
      "menu",
      "navigation",
      "orienteering",
      "safari",
      "travel"
    ]
  },
  {
    id: "heart-crack",
    label: "Heart Crack",
    search: [
      "break",
      "breakup",
      "broken",
      "broken heart",
      "crushed",
      "dislike",
      "dumped",
      "grief",
      "love",
      "lovesick",
      "relationship",
      "sad"
    ]
  },
  {
    id: "8",
    label: "8",
    search: [
      "Digit Eight",
      "eight"
    ]
  },
  {
    id: "flag",
    label: "Flag",
    search: [
      "black flag",
      "country",
      "notice",
      "notification",
      "notify",
      "pole",
      "report",
      "symbol",
      "waving"
    ]
  },
  {
    id: "right",
    label: "Right",
    search: [
      "Rightwards Black Arrow",
      "forward",
      "next"
    ]
  },
  {
    id: "chevron-up",
    label: "Chevron Up",
    search: [
      "arrow",
      "collapse",
      "upgrade",
      "upload"
    ]
  },
  {
    id: "stopwatch",
    label: "Stopwatch",
    search: [
      "clock",
      "reminder",
      "stopwatch",
      "time",
      "waiting"
    ]
  },
  {
    id: "5",
    label: "5",
    search: [
      "Digit Five",
      "five"
    ]
  },
  {
    id: "stairs",
    label: "Stairs",
    search: [
      "exit",
      "steps",
      "up"
    ]
  },
  {
    id: "user-helmet-safety",
    label: "User Helmet Safety",
    search: [
      "construction",
      "construction worker",
      "employee",
      "hardhat",
      "hat",
      "helmet",
      "maintenance",
      "safety",
      "uer",
      "worker"
    ]
  },
  {
    id: "shield-check",
    label: "Shield Check",
    search: [
      "achievement",
      "award",
      "block",
      "defend",
      "enable",
      "protect",
      "safety",
      "security",
      "select",
      "success",
      "tick",
      "todo",
      "validate",
      "warranty",
      "winner",
      "working"
    ]
  },
  {
    id: "6",
    label: "6",
    search: [
      "Digit Six",
      "six"
    ]
  },
  {
    id: "radiation",
    label: "Radiation",
    search: [
      "danger",
      "dangerous",
      "deadly",
      "hazard",
      "nuclear",
      "radioactive",
      "warning"
    ]
  },
  {
    id: "key",
    label: "Key",
    search: [
      "key",
      "lock",
      "password",
      "private",
      "secret",
      "unlock"
    ]
  },
  {
    id: "star",
    label: "Star",
    search: [
      "achievement",
      "award",
      "favorite",
      "important",
      "night",
      "quality",
      "rating",
      "score",
      "star",
      "vip"
    ]
  },
  {
    id: "arrow-up-left",
    label: "Arrow Up Left",
    search: [
      "diagonal",
      "northwest"
    ]
  },
  {
    id: "person-to-portal",
    label: "Person To Portal",
    search: [
      "portal",
      "run",
      "transport",
      "travel",
      "uer"
    ]
  },
  {
    id: "books",
    label: "Books",
    search: [
      "book",
      "books",
      "diary",
      "documentation",
      "journal",
      "knowledge",
      "library",
      "read",
      "research",
      "scholar"
    ]
  },
  {
    id: "fire",
    label: "Fire",
    search: [
      "burn",
      "caliente",
      "fire",
      "flame",
      "heat",
      "hot",
      "popular",
      "tool"
    ]
  },
  {
    id: "microphone",
    label: "Microphone",
    search: [
      "address",
      "audio",
      "information",
      "podcast",
      "public",
      "record",
      "sing",
      "sound",
      "talking",
      "voice"
    ]
  },
  {
    id: "3",
    label: "3",
    search: [
      "Digit Three",
      "three"
    ]
  },
  {
    id: "down-from-line",
    label: "Down From Line",
    search: [
      "download",
      "export",
      "insert",
      "transfer"
    ]
  },
  {
    id: "caret-up",
    label: "Caret Up",
    search: [
      "arrow",
      "collapse",
      "triangle",
      "upgrade"
    ]
  },
  {
    id: "handshake",
    label: "Handshake",
    search: [
      "agreement",
      "greeting",
      "meeting",
      "partnership"
    ]
  },
  {
    id: "360-degrees",
    label: "360 Degrees",
    search: [
      "3D",
      "panorama",
      "revolve",
      "rotate"
    ]
  },
  {
    id: "bomb",
    label: "Bomb",
    search: [
      "bomb",
      "comic",
      "error",
      "explode",
      "fuse",
      "grenade",
      "warning"
    ]
  },
  {
    id: "palette",
    label: "Palette",
    search: [
      "acrylic",
      "art",
      "artist palette",
      "brush",
      "color",
      "fill",
      "museum",
      "paint",
      "painting",
      "palette",
      "pigment",
      "watercolor"
    ]
  },
  {
    id: "bullseye-arrow",
    label: "Bullseye Arrow",
    search: [
      "archery",
      "arrow",
      "bullseye",
      "dart",
      "direct hit",
      "game",
      "goal",
      "hit",
      "objective",
      "robin hood",
      "strategy",
      "target"
    ]
  },
  {
    id: "left",
    label: "Left",
    search: [
      "back",
      "previous"
    ]
  },
  {
    id: "question",
    label: "Question",
    search: [
      "?",
      "Question Mark",
      "faq",
      "help",
      "information",
      "mark",
      "outlined",
      "punctuation",
      "question",
      "red question mark",
      "request",
      "support",
      "unknown",
      "white question mark"
    ]
  },
  {
    id: "road",
    label: "Road",
    search: [
      "highway",
      "map",
      "motorway",
      "pavement",
      "road",
      "route",
      "street",
      "travel"
    ]
  },
  {
    id: "helmet-safety",
    label: "Helmet Safety",
    search: [
      "construction",
      "hardhat",
      "helmet",
      "maintenance",
      "safety"
    ]
  },
  {
    id: "arrow-right",
    label: "Arrow Right",
    search: [
      "Rightwards Arrow",
      "forward",
      "next"
    ]
  },
  {
    id: "heart",
    label: "Heart",
    search: [
      "ace",
      "black",
      "black heart",
      "blue",
      "blue heart",
      "brown",
      "brown heart",
      "card",
      "evil",
      "favorite",
      "game",
      "green",
      "green heart",
      "heart",
      "heart suit",
      "like",
      "love",
      "orange",
      "orange heart",
      "purple",
      "purple heart",
      "red heart",
      "relationship",
      "valentine",
      "white",
      "white heart",
      "wicked",
      "wishlist",
      "yellow",
      "yellow heart"
    ]
  },
  {
    id: "circle",
    label: "Circle",
    search: [
      "Black Circle",
      "Black Large Circle",
      "black circle",
      "blue",
      "blue circle",
      "brown",
      "brown circle",
      "chart",
      "circle",
      "circle-thin",
      "diameter",
      "dot",
      "ellipse",
      "fill",
      "geometric",
      "green",
      "green circle",
      "notification",
      "orange",
      "orange circle",
      "progress",
      "purple",
      "purple circle",
      "red",
      "red circle",
      "round",
      "white circle",
      "yellow",
      "yellow circle"
    ]
  },
  {
    id: "wrench",
    label: "Wrench",
    search: [
      "configuration",
      "construction",
      "equipment",
      "fix",
      "mechanic",
      "modify",
      "plumbing",
      "settings",
      "spanner",
      "tool",
      "update",
      "wrench"
    ]
  },
  {
    id: "arrow-up-right",
    label: "Arrow Up Right",
    search: [
      "diagonal",
      "northeast"
    ]
  },
  {
    id: "hand-pointer",
    label: "Hand Pointer",
    search: [
      "arrow",
      "cursor",
      "select"
    ]
  },
  {
    id: "arrow-rotate-right",
    label: "Arrow Rotate Right",
    search: [
      "Clockwise Open Circle Arrow",
      "forward",
      "refresh",
      "reload",
      "renew",
      "repeat",
      "retry"
    ]
  },
  {
    id: "0",
    label: "0",
    search: [
      "Digit Zero",
      "nada",
      "none",
      "zero",
      "zilch"
    ]
  },
  {
    id: "arrow-left",
    label: "Arrow Left",
    search: [
      "Leftwards Arrow",
      "back",
      "previous"
    ]
  },
  {
    id: "camera",
    label: "Camera",
    search: [
      "image",
      "img",
      "lens",
      "photo",
      "picture",
      "record",
      "shutter",
      "video"
    ]
  },
  {
    id: "arrow-rotate-left",
    label: "Arrow Rotate Left",
    search: [
      "Anticlockwise Open Circle Arrow",
      "back",
      "control z",
      "exchange",
      "oops",
      "return",
      "rotate",
      "swap"
    ]
  },
  {
    id: "arrow-down-right",
    label: "Arrow Down Right",
    search: [
      "diagonal",
      "southeast"
    ]
  },
  {
    id: "minus",
    label: "Minus",
    search: [
      "En Dash",
      "Minus Sign",
      "collapse",
      "delete",
      "hide",
      "math",
      "minify",
      "minus",
      "negative",
      "remove",
      "sign",
      "trash",
      "−"
    ]
  },
  {
    id: "arrow-down-left",
    label: "Arrow Down Left",
    search: [
      "diagonal",
      "southwest"
    ]
  },
  {
    id: "gear",
    label: "Gear",
    search: [
      "cog",
      "cogwheel",
      "configuration",
      "gear",
      "mechanical",
      "modify",
      "settings",
      "sprocket",
      "tool",
      "wheel"
    ]
  },
  {
    id: "clock",
    label: "Clock",
    search: [
      "00",
      "4",
      "4:00",
      "clock",
      "date",
      "four",
      "four o’clock",
      "hour",
      "late",
      "minute",
      "o'clock",
      "o’clock",
      "pending",
      "schedule",
      "ticking",
      "time",
      "timer",
      "timestamp",
      "watch"
    ]
  },
  {
    id: "map-pin",
    label: "Map Pin",
    search: [
      "address",
      "agree",
      "coordinates",
      "destination",
      "gps",
      "localize",
      "location",
      "map",
      "marker",
      "navigation",
      "pin",
      "place",
      "position",
      "pushpin",
      "round pushpin",
      "travel"
    ]
  },
  {
    id: "calculator",
    label: "Calculator",
    search: [
      "Pocket Calculator",
      "abacus",
      "addition",
      "arithmetic",
      "counting",
      "math",
      "multiplication",
      "subtraction"
    ]
  },
  {
    id: "ship",
    label: "Ship",
    search: [
      "boat",
      "passenger",
      "sea",
      "ship",
      "water"
    ]
  },
  {
    id: "kit-medical",
    label: "Kit Medical",
    search: [
      "emergency",
      "emt",
      "health",
      "medical",
      "rescue"
    ]
  },
  {
    id: "location-dot",
    label: "Location Dot",
    search: [
      "address",
      "coordinates",
      "destination",
      "gps",
      "localize",
      "location",
      "map",
      "navigation",
      "paper",
      "pin",
      "place",
      "point of interest",
      "position",
      "route",
      "travel"
    ]
  },
  {
    id: "arrow-down",
    label: "Arrow Down",
    search: [
      "Downwards Arrow",
      "download"
    ]
  },
  {
    id: "earth-americas",
    label: "Earth Americas",
    search: [
      "all",
      "america",
      "country",
      "earth",
      "global",
      "globe",
      "gps",
      "language",
      "localize",
      "location",
      "map",
      "online",
      "place",
      "planet",
      "translate",
      "travel",
      "world"
    ]
  },
  {
    id: "magnifying-glass",
    label: "Magnifying Glass",
    search: [
      "bigger",
      "enlarge",
      "equipment",
      "find",
      "glass",
      "inspection",
      "magnifier",
      "magnify",
      "magnifying",
      "magnifying glass tilted left",
      "preview",
      "search",
      "tool",
      "zoom"
    ]
  },
  {
    id: "chevron-down",
    label: "Chevron Down",
    search: [
      "arrow",
      "download",
      "expand",
      "insert"
    ]
  },
  {
    id: "arrow-up",
    label: "Arrow Up",
    search: [
      "Upwards Arrow",
      "forward",
      "upgrade",
      "upload"
    ]
  },
  {
    id: "2",
    label: "2",
    search: [
      "Digit Two",
      "two"
    ]
  },
  {
    id: "plus",
    label: "Plus",
    search: [
      "+",
      "Plus Sign",
      "add",
      "create",
      "expand",
      "follow",
      "math",
      "modify",
      "new",
      "plus",
      "positive",
      "shape",
      "sign"
    ]
  },
  {
    id: "xmark",
    label: "Xmark",
    search: [
      "Cancellation X",
      "Multiplication Sign",
      "Multiplication X",
      "cancel",
      "close",
      "cross",
      "cross mark",
      "error",
      "exit",
      "incorrect",
      "mark",
      "multiplication",
      "multiply",
      "notice",
      "notification",
      "notify",
      "problem",
      "sign",
      "uncheck",
      "wrong",
      "x",
      "×"
    ]
  },
  {
    id: "cars",
    label: "Cars",
    search: [
      "automobiles",
      "autos",
      "transportation",
      "travel"
    ]
  },
  {
    id: "map",
    label: "Map",
    search: [
      "address",
      "coordinates",
      "destination",
      "gps",
      "localize",
      "location",
      "map",
      "navigation",
      "paper",
      "pin",
      "place",
      "point of interest",
      "position",
      "route",
      "travel",
      "world",
      "world map"
    ]
  },
  {
    id: "chevron-left",
    label: "Chevron Left",
    search: [
      "Left-Pointing Angle Bracket",
      "arrow",
      "back",
      "bracket",
      "previous"
    ]
  },
  {
    id: "person-to-door",
    label: "Person To Door",
    search: [
      "door",
      "exit",
      "leave",
      "uer"
    ]
  },
  {
    id: "briefcase-medical",
    label: "Briefcase Medical",
    search: [
      "doctor",
      "emt",
      "first aid",
      "health"
    ]
  },
  {
    id: "chevron-right",
    label: "Chevron Right",
    search: [
      "Right-Pointing Angle Bracket",
      "arrow",
      "bracket",
      "forward",
      "next"
    ]
  },
  {
    id: "anchor",
    label: "Anchor",
    search: [
      "anchor",
      "berth",
      "boat",
      "dock",
      "embed",
      "link",
      "maritime",
      "moor",
      "port",
      "secure",
      "ship",
      "tool"
    ]
  },
  {
    id: "4",
    label: "4",
    search: [
      "Digit Four",
      "four"
    ]
  },
  {
    id: "book",
    label: "Book",
    search: [
      "book",
      "cover",
      "decorated",
      "diary",
      "documentation",
      "journal",
      "knowledge",
      "library",
      "notebook",
      "notebook with decorative cover",
      "read",
      "research",
      "scholar"
    ]
  },
  {
    id: "check",
    label: "Check",
    search: [
      "Check Mark",
      "accept",
      "agree",
      "check",
      "check mark",
      "checkmark",
      "confirm",
      "correct",
      "coupon",
      "done",
      "enable",
      "mark",
      "notice",
      "notification",
      "notify",
      "ok",
      "select",
      "success",
      "tick",
      "todo",
      "true",
      "validate",
      "working",
      "yes",
      "✓"
    ]
  },
  {
    id: "briefcase",
    label: "Briefcase",
    search: [
      "bag",
      "briefcas",
      "briefcase",
      "business",
      "luggage",
      "offer",
      "office",
      "portfolio",
      "work"
    ]
  },
  {
    id: "triangle-exclamation",
    label: "Triangle Exclamation",
    search: [
      "alert",
      "attention",
      "danger",
      "error",
      "failed",
      "important",
      "notice",
      "notification",
      "notify",
      "problem",
      "required",
      "warnin",
      "warning"
    ]
  },
  {
    id: "bandage",
    label: "Bandage",
    search: [
      "adhesive bandage",
      "bandage",
      "boo boo",
      "first aid",
      "modify",
      "ouch"
    ]
  },
  {
    id: "9",
    label: "9",
    search: [
      "Digit Nine",
      "nine"
    ]
  },
  {
    id: "magnifying-glass-plus",
    label: "Magnifying Glass Plus",
    search: [
      "bigger",
      "enlarge",
      "magnifier",
      "magnify",
      "positive",
      "zoom",
      "zoom in"
    ]
  },
  {
    id: "thumbs-up",
    label: "Thumbs Up",
    search: [
      "+1",
      "agree",
      "approve",
      "favorite",
      "hand",
      "like",
      "ok",
      "okay",
      "social",
      "success",
      "thumb",
      "thumbs up",
      "thumbs-o-up",
      "up",
      "yes",
      "you got it dude"
    ]
  },
  {
    id: "magnifying-glass-minus",
    label: "Magnifying Glass Minus",
    search: [
      "magnifier",
      "minify",
      "negative",
      "smaller",
      "zoom",
      "zoom out"
    ]
  },
  {
    id: "1",
    label: "1",
    search: [
      "Digit One",
      "one"
    ]
  },
  {
    id: "down",
    label: "Down",
    search: [
      "download",
      "insert"
    ]
  },
  {
    id: "plane",
    label: "Plane",
    search: [
      "airplane",
      "airport",
      "destination",
      "fly",
      "location",
      "mode",
      "travel",
      "trip"
    ]
  },
  {
    id: "exclamation",
    label: "Exclamation",
    search: [
      "!",
      "Exclamation Mark",
      "alert",
      "attention",
      "danger",
      "error",
      "exclamation",
      "failed",
      "important",
      "mark",
      "notice",
      "notification",
      "notify",
      "outlined",
      "problem",
      "punctuation",
      "red exclamation mark",
      "required",
      "warning",
      "white exclamation mark"
    ]
  },
  {
    id: "video",
    label: "Video",
    search: [
      "camera",
      "film",
      "movie",
      "record",
      "video-camera"
    ]
  },
  {
    id: "graduation-cap",
    label: "Graduation Cap",
    search: [
      "cap",
      "celebration",
      "ceremony",
      "clothing",
      "college",
      "graduate",
      "graduation",
      "graduation cap",
      "hat",
      "learning",
      "school",
      "student"
    ]
  }
], $e = {
  0: Fr,
  1: Gr,
  2: Ir,
  3: Or,
  "360-degrees": jr,
  4: Vr,
  5: Xr,
  6: Kr,
  7: Qr,
  8: Nr,
  9: Wr,
  anchor: Zr,
  "arrow-down-left": Jr,
  "arrow-down-right": Yr,
  "arrow-down": _r,
  "arrow-left": ro,
  "arrow-right": oo,
  "arrow-rotate-left": eo,
  "arrow-rotate-right": ao,
  "arrow-up-left": io,
  "arrow-up-right": to,
  "arrow-up": lo,
  bandage: mo,
  bomb: no,
  book: co,
  books: so,
  "briefcase-medical": po,
  briefcase: fo,
  "bullseye-arrow": ho,
  calculator: go,
  camera: uo,
  "caret-up": wo,
  cars: bo,
  check: Uo,
  "chevron-down": ko,
  "chevron-left": yo,
  "chevron-right": vo,
  "chevron-up": $o,
  circle: xo,
  clock: Ao,
  compass: Co,
  "door-open": Do,
  "down-from-line": zo,
  down: So,
  "earth-americas": Mo,
  exclamation: qo,
  fire: Po,
  flag: Ro,
  gear: Bo,
  "graduation-cap": Lo,
  "hand-pointer": To,
  handshake: Eo,
  "heart-crack": Ho,
  heart: Fo,
  "helmet-safety": Go,
  info: Io,
  key: Oo,
  "kit-medical": jo,
  left: Vo,
  "location-dot": Xo,
  "magnifying-glass-minus": Ko,
  "magnifying-glass-plus": Qo,
  "magnifying-glass": No,
  "map-pin": Wo,
  map: Zo,
  microphone: Jo,
  minus: Yo,
  palette: _o,
  pencil: re,
  "person-to-door": oe,
  "person-to-portal": ee,
  plane: ae,
  plus: ie,
  question: te,
  radiation: le,
  reply: me,
  right: ne,
  road: ce,
  "shield-check": se,
  ship: pe,
  stairs: de,
  star: fe,
  stopwatch: he,
  "thumbs-up": ge,
  "triangle-exclamation": ue,
  up: we,
  "user-helmet-safety": be,
  video: Ue,
  wrench: ke,
  xmark: ye
}, Vt = {
  /***
   * Contains URL to a sprite with SVGs.
   */
  iconsSpriteUrl: Hr,
  /***
   * Icons available in the bundle.
   */
  icons: {
    /***
     * List of icons with metadata.
     */
    list: ve,
    /***
     * Contains an identifier of the icon and the url to download the icon.
     * Every icon in the sprite is here.
     */
    urls: r,
    /***
     * Contains an identifier of the tilted icon and the url to download the icon.
     * Every icon in the sprite is here.
     */
    tiltedUrls: $e
  }
};
export {
  Vt as VirtualTourIconsBundle,
  jt as isVirtualTourIconId
};
